import { browserUtil, tokenService } from '../../common'

export class AuthInitiate {
  public get Name(): string {
    return 'Auth'
  }

  protected _redirectIfTokenNotPresent(): void {
    if (!tokenService.hasAccessToken()) {
      const currentUrl = browserUtil.location()
      const redirectSearchParams = new URLSearchParams({ redirect: currentUrl })
      browserUtil.redirect(`/auth/get-in?${redirectSearchParams.toString()}`)
      const errorMessage = 'User is not authorised, redirecting to authorisation page'
      throw Error(errorMessage)
    }
  }

  protected async _destroyFn(): Promise<void> {
    return Promise.resolve(undefined)
  }

  protected async _initFn(): Promise<void> {
    this._redirectIfTokenNotPresent()
  }
}
